// <s-purchase-type>: "Štandardný nákup" / "Úschova" cards on the product page. Picking a card puts that card's
// variant ID into the product form's id input, so Kúpiť adds the standard product or its úschova product.
// The cards are re-rendered with the product form on variant change and start again on Štandardný nákup.

class PurchaseType extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener(
      'change',
      (event) => {
        const radio = event.target.closest('input[name="purchase_type"]');
        if (!radio) return;
        event.stopPropagation(); // keep s-variant-picker from treating this as an option change
        const form = this.closest('form');
        const idInput = form?.querySelector('input[name="id"]');
        if (idInput && radio.dataset.variantId) idInput.value = radio.dataset.variantId;
        // Úschova: show the guest sign-in notice and hide accelerated checkout (it would skip the cart).
        const isStorage = radio.value === 'storage';
        form?.querySelectorAll('[data-uschova-only]').forEach((el) => { el.hidden = !isStorage; });
        form?.querySelectorAll('[data-uschova-hide]').forEach((el) => { el.hidden = isStorage; });
      },
      { signal: this.#controller.signal },
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-purchase-type')) customElements.define('s-purchase-type', PurchaseType);
